import {format, parseISO} from "date-fns";
import PropTypes from "prop-types";
import React from "react";

export function Date({ isoDateString }) {
    return <>{format(parseISO(isoDateString), "MMMM d, y")}</>;
}

Date.propTypes = {
    isoDateString: PropTypes.string.isRequired,
};
